module.exports = {
  fetch: `
    query getTreatments {
      treatments {
        ...on Treatment {
          id
          name {
            en
            es
          }
          category
          displayOrder
          disableToggle
          components {
            key
            label {
              en
              es
            }
            type
            metadata
          }
        }
        ...on IVTreatment {
          id
          name {
            en
            es
          }
          sides {
            label {
              en
              es
            }
            key
          }
          sites {
            label {
              en
              es
            }
            key
          }
          fluidRates {
            label {
              en
              es
            }
            key
          }
          volumes
          needleGauges
          needleSets
          tubings
          category
          expectsFluid
        }
        ...on IVFluid {
          id
          name {
            en
            es
          }
          category
        }
        __typename
      }
    }
  `,
};
